import { ThemeProvider as NextThemesProvider } from "next-themes";

export function ThemeProvider({ children }: { children: React.ReactNode }) {
  // The app defaults to light mode for everyone; each user may switch to dark
  // via the top-bar toggle (persisted per browser). enableSystem is off so the
  // OS preference never overrides the light default — dark is an explicit,
  // per-user opt-in, not an admin-set or OS-driven choice (WI-082).
  return (
    <NextThemesProvider attribute="class" defaultTheme="light" enableSystem={false}>
      {children}
    </NextThemesProvider>
  );
}
